import { useEffect, useRef, useState } from 'react';

export const useIntersectionObserver = (
    options: IntersectionObserverInit = { threshold: 0.5 },
): [React.MutableRefObject<null>, boolean] => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            setIsIntersecting(entry.isIntersecting);
        }, options);

        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref, options]);

    return [ref, isIntersecting];
};
